import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

import { SpanItalicizedStyled } from './styles';

export default () => (
  <SectionContainer
    id='annuity-faq-annuity-value'
    backgroundVariant='lightA'
    disableBottomPadding>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h2'
          nextElement='typography'>
          Determine Your Annuity&#39;s Value
        </Typography>
        <Typography nextElement='typography'>
          The number of &#34;accumulation units&#34; in each investment division determines the value of a variable annuity. Accumulation units represent your interest, as an annuity owner, in each investment division.
        </Typography>
        <Typography nextElement='typography'>
          Every time you make a contribution to your Northwestern Mutual Select&#8482; Variable Annuity, you are purchasing accumulation units in one or more investment divisions, as you direct.
        </Typography>
        <Typography nextElement='typography'>
          To determine how many units you are purchasing with your contribution:
        </Typography>
        <BulletedList
          bulletedListData={[
            { bulletText: 'Divide the portion of the contribution to be allocated to an investment division, by the value of an accumulation unit in that division.' },
          ]}
        />
        <Typography nextElement='typography'>
          The value of an accumulation unit in an investment division will vary based on the investment experience of the division. The value of your Northwestern Mutual Select&#8482; Variable Annuity contract will also fluctuate so that the accumulation value at maturity or surrender may be more or less than the original cost.
        </Typography>
        <Typography nextElement='typography'>
          <strong>Finding Contract&#45;Specific Values</strong>
        </Typography>
        <Typography nextElement='typography'>
          You can find the value of your Northwestern Mutual Select&#8482; Variable Annuity by:
        </Typography>
        <BulletedList
          bulletedListData={[
            { bulletText: 'Checking your personal policy information on the Customer Center secured site.' },
            { bulletText: 'Reading your financial confirmation statement or quarterly summary statement. If you have misplaced your statement, call your Representative or Northwestern Mutual.' },
          ]}
        />
        <Typography nextElement='typography'>
          <strong>Note:</strong> When calling or logging onto the secure site, have your annuity contract number and personal identification number &#40;PIN&#41; ready.
        </Typography>
        <Typography nextElement='typography'>
          <SpanItalicizedStyled>The assets underlying each investment division are valued as of the close of trading on the New York Stock Exchange for each day it is open, and at any other time required by the Investment Company Act of 1940.</SpanItalicizedStyled>
        </Typography>
        <Typography disableBottomPadding>
          <SpanItalicizedStyled>Distributions may be subject to ordinary income tax and may be subject to a 10&#37; IRS early withdrawal penalty if taken before age
            59&#189;.
          </SpanItalicizedStyled>
        </Typography>
      </Col>
    </Row>
  </SectionContainer>
);
